import React from "react";
import { Container, Typography } from "@mui/material";
import { privacyPolicyData } from "../data/privacy-policy-data";
import "../styles/privacy-policy.css";

interface PrivacyPolicyProps {}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = () => {
  return (
    <>
      <div className="page-header"></div>
      <div className="privacy-policy-body">
        <div className="privacy-policy-contact">
          <Container sx={{ py: 9 }} maxWidth="md">
            <Typography
              className="text-header"
              variant="h3"
              sx={{ mb: 3 }}
              style={{
                fontWeight: "bold",
                backgroundImage: "linear-gradient(100deg,#61D2FF,#FFA3E1)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {privacyPolicyData?.title}
            </Typography>
            {privacyPolicyData?.sections.map((section) => (
              <React.Fragment key={"section.title"}>
                <Typography
                  variant="h5"
                  style={{ fontWeight: "bold", color: "#9679a5" }}
                >
                  {section.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mb: 3, whiteSpace: "pre-line" }}
                >
                  {section.description}
                </Typography>
              </React.Fragment>
            ))}
          </Container>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
